import { useChannelTalk } from '@repo/channel-talk';
import { useWorkingPlatform } from '@repo/platform';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import UnexpectedError from '@/components/tax-refund/common/view/ErrorView/UnexpectedError';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { useExitService } from '@/lib/hooks/use-exit-service';

const ErrorPage = () => {
  const router = useRouter();
  const { openChannelTalk } = useChannelTalk();
  const { workingPlatformType } = useWorkingPlatform();
  const { exitService } = useExitService();

  const handleClickExit = () => {
    if (workingPlatformType === 'web') {
      router.push({
        pathname: '/home/landing',
        query: router.query
      });
    } else {
      exitService();
    }
  };

  const handleAsk = () => {
    openChannelTalk(SUPPORT_BOT_LINK.errors);
  };
  return (
    <AuthGuard>
      <Layout
        rightTextButton={{
          label: '나가기',
          state: 'gray',
          onClick: handleClickExit
        }}
      >
        <UnexpectedError onPrimaryButtonClick={handleAsk} />
      </Layout>
    </AuthGuard>
  );
};

export default ErrorPage;
